const UTILS = {
  FormSubmitAjax (form) {
    return fetch(form.action, { method: 'POST', body: new FormData(form) });
  },
  AddItemsToCart: (itemsToAdd) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    });
  },
  ChangeLineItem(p_options) {
    let data = {
      id: p_options.id || p_options.key,
      quantity: p_options.quantity || 1,
      properties: p_options.properties || {}
    }
  
    let url = `/cart/change.js`;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(res => res.json());
  },
  UpdateCartItems(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    }).then(res => res.json());
  },
  GetCartJson() {
    return fetch('/cart.js').then(res => res.json());
  },
  GetProductJS(product_handle) {
    return fetch(`/products/${ product_handle }.js`).then(res => res.json());
  },
  GetSections(sections) {
    return fetch(`/?sections=${ sections }`).then(res => res.json());
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('AddToCartOnPage', () => ({
    $button: null,
    init() {
      let am = this;
      document.addEventListener('init-AddToCartOnPage', (e) => {
        if (am.$button) return;
        am.$button = e.target;
      });
    },
    SubmitAddToCartForm(e) {
      let am = this;
      e.preventDefault();
      const CLASS_ADDED_TO_CART = 'add-to-cart-complete';
      let $form = e.target.closest('.product-single__form');
      if (am.$button.classList.contains(CLASS_ADDED_TO_CART)) {
        window.location.href = '/cart';
        return;
      }

      (async() => {
        let rx_form = await UTILS.FormSubmitAjax($form);
        if (rx_form.ok) {
          am.$button.querySelector('[data-add-to-cart-text]').textContent = 'Added! Click to View Cart';
          am.$button.classList.add(CLASS_ADDED_TO_CART);
          am.RefreshCart();
        }
        else {
          console.error(rx_form.error);
        }
      })();
    },
    RefreshCart() {
      document.querySelectorAll('.cart-link__bubble').forEach(($cart_bubble) => {
        $cart_bubble.classList.add('cart-link__bubble--visible');
      });
    }
  }));

  Alpine.data('CustomDropdown', () => ({
    $section: null,
    init() {
      let am = this;
      document.addEventListener('init-CustomDropdown', (e) => {
        if (am.$section) return;
        am.$section = e.target;
      });
    },
    CloseDropdown(e) {
      let am = this;
      am.$section.removeAttribute('open');
    }
  }));

  Alpine.data('ProductFormGridItem', () => ({
    $section: null,
    selected_variant_title: '',
    init() {
      let am = this;
      document.addEventListener('init-ProductFormGridItem', (e) => {
        if (am.$section) return;
        am.$section = e.target;
      });
    }
  }));

  Alpine.data('CartAddon', (addon_handle) => ({
    $section: null,
    addonProduct: null,
    init() {
      let am = this;
      document.addEventListener('init-CartAddon', (e) => {
        if (am.$section) return;
        am.$section = e.target;
      });

      // load addon product
      (async() => {
        let product = await UTILS.GetProductJS(addon_handle);
        am.addonProduct = product;
        setTimeout(am.UpdateAddons.bind(am), 1000); // on page load
      })();
    },
    UpdateAddons(e) {
      let am = this;
      let line_item_key = am.$section.dataset.key;

      (async() => {
        let cart = await UTILS.GetCartJson();
        let line_item = cart.items.find(item => item.key == line_item_key);

        // update main item to indicate which addon variant goes together
        if (e) {
          let addon_variant_id = e.target.value;
          let color = e.target.dataset.color;
          cart = await UTILS.ChangeLineItem({
            id: line_item_key,
            quantity: line_item.quantity,
            properties: {
              _addon: addon_variant_id,
              'Metal Tip': color
            }
          });  
        }

        // update addon variant
        let lineitems_req_addons = cart.items.filter(item => item.properties['_addon'] && item.properties['_addon'] !== 'None');
        let req_addons = lineitems_req_addons.map(item => item.properties['_addon']);
        req_addons = [...new Set(req_addons)]; // remove duplicates

        // calculate qty for each addon variant
        req_addons = req_addons.map((addon_variant_id) => {
          let qty = 
            cart.items
            .filter(item => item.properties && item.properties['_addon'] == addon_variant_id)
            .reduce((sum, item) => (sum + item.quantity), 0);
          return {
            id: addon_variant_id,
            quantity: qty
          };
        });

        let cart_addons_updates = {};

        am.addonProduct.variants.forEach((addon_variant) => {
          let item_in_cart = cart.items.find(item => item.id == addon_variant.id);
          let req_item = req_addons.find(item => item.id == addon_variant.id);
          let req_qty = req_item ? req_item.quantity : 0;

          let quantity = req_qty;

          if (item_in_cart) {
            if (item_in_cart.quantity !== quantity) {
              cart_addons_updates[addon_variant.id] = quantity;
            }
          }
          else {
            if (quantity > 0) {
              cart_addons_updates[addon_variant.id] = quantity;
            }
          }
        });

        // debugger;
        if (JSON.stringify(cart_addons_updates) !== '{}') {
          await UTILS.UpdateCartItems(cart_addons_updates)
          am.RefreshCart();
        }
      })();
    },
    RefreshCart() {
      let am = this;
      // window.location.reload();
      (async() => {
        let res_cart = await UTILS.GetSections('main-cart');
        // document.querySelector('shopify-section-main-cart').innerHTML = res_cart['main_cart'];

        let $main_cart = UTILS.ConvertStringToHTML(res_cart['main-cart']);
        document.querySelector('#cart-page-content').innerHTML = $main_cart.querySelector('#cart-page-content').innerHTML;
        AOS.init();

        var cartPageForm = document.getElementById('CartPageForm');
        if (cartPageForm) {
          new theme.CartForm(cartPageForm);
        }  
      })();
    }
  }));
});